import Vue from 'vue'
import Vuex from 'vuex'
import themeStyle from '@/assets/js/theme-style.js';
Vue.use(Vuex)

function defaultTheme() {
	localStorage.setItem('theme', 'dark');
	let state = `dark`
	return state;
}

function defaultExchangeRate() {
	localStorage.setItem('exchangeRate', 'USD');
	let state = `USD`
	return state;
}
export default new Vuex.Store({
	state: {
		ws: 'wss://server.betawallet.net/ws1',
		baseUrl: 'https://server.betawallet.net/',
		 // 地址
		 isLink: false,
		 
		// 主题
		theme: localStorage.getItem('theme') || defaultTheme(),
		// 汇率
		exchangeRate: localStorage.getItem('exchangeRate') || defaultExchangeRate(),
		RateName: localStorage.getItem('RateName') || '',
		RateMoney: localStorage.getItem('RateMoney') || '',
		// 区号列表
		countryList: [],
		// 用户
		member: JSON.parse(localStorage.getItem('MEMBER')) || null,
		users: JSON.parse(localStorage.getItem('users')) || [], // 所有的用户信息
		currentUserIndex: JSON.parse(localStorage.getItem('currentUserIndex')) || -1 // 当前登录用户的索引，初始化为-1，表示当前没有用户登

	},
	getters: {
		themeStyle(state) {
			return themeStyle[state.theme]
		},
		isLogin(state) {
			return state.member != null;
		},
		member(state) {
			return state.member;
		},
		currentUser: state => {
			if (state.currentUserIndex >= 0 && state.currentUserIndex < state.users.length) {
				return state.users[state.currentUserIndex]
			} else {
				return null
			}
		}

	},
	mutations: {
		
		isPcChange(state, val) {
            state.isPc = val
        },
		// 设置主题
		THEME(state, data) {
			state.theme = data
			localStorage.setItem('theme', data)
		},
		// 设置汇率
		EXCHANGETATE(state, data) {
			state.exchangeRate = data
			localStorage.setItem('exchangeRate', data)
		},
		//设置汇率单位
		RATENAME(state, data) {
			state.RateName = data
			localStorage.setItem('RateName', data)
		},
		// 设置区号
		COUNTRYLIST(state, data) {
			state.countryList = data
		},
		setMember(state, member) {
			state.member = member;
			localStorage.setItem('MEMBER', JSON.stringify(member));
		},
		recoveryMember(state) {
			state.member = JSON.parse(localStorage.getItem('MEMBER'));
		},
		login(state, {
			username,
			password
		}) {
			// 判断用户是否已经存在
			const existingUser = state.users.find(user => user.username === username)
			if (existingUser) {
				// 如果用户已经存在，就更新用户的密码
				existingUser.password = password;
				existingUser.username = username
				state.currentUserIndex = state.users.indexOf(existingUser)
			} else {
				// 如果用户不存在，就创建一个新用户
				const user = {
					username,
					password
				}
				state.users.push(user)
				state.currentUserIndex = state.users.indexOf(user)
			}
			localStorage.setItem('users', JSON.stringify(state.users))
			localStorage.setItem('currentUserIndex', state.currentUserIndex.toString())

		},
		logout(state) {
			// 注销当前用户
			state.currentUserIndex = -1
			// 从localStorage中删除登录状态
			localStorage.removeItem('currentUserIndex')
		},
		switchUser(state, index) {
			// 切换当前登录用户
			if (index >= 0 && index < state.users.length) {
				state.currentUserIndex = index
				// 将登录状态保存到localStorage中
				localStorage.setItem('currentUserIndex', index.toString())
			}
		},
		loadUsers(state) {
			// 加载用户信息和登录状态
			const users = JSON.parse(localStorage.getItem('users')) || []
			state.users = users
			const currentUserIndex = parseInt(localStorage.getItem('currentUserIndex'))
			if (!isNaN(currentUserIndex) && currentUserIndex >= 0 && currentUserIndex < users.length) {
				state.currentUserIndex = currentUserIndex;
			
			}
		},
		deleteUser(state, user) {
			const index = state.users.indexOf(user)
			if (index >= 0) {
				state.users.splice(index, 1) // 从用户列表中删除指定用户
				localStorage.setItem('users', JSON.stringify(state.users))

				// 如果删除的是当前用户，就退出登录
				if (index === state.currentUserIndex) {
					state.currentUserIndex = -1
					localStorage.removeItem('currentUserIndex')
				
				}
			}
		},
	},
	actions: {

		// 设置主题
		setTheme({
			commit
		}, data) {
			commit('THEME', data)
		},
		// 设置汇率
		setExchangeRate({
			commit
		}, data) {
			commit('EXCHANGETATE', data)
		},
		// 设置汇率单位
		setRateName({
			commit
		}, data) {
			commit('RATENAME', data)
		},
		// 设置区号
		countryList({
			commit
		}, data) {
			commit('COUNTRYLIST', data)
		},
		loadUsers({
			commit
		}) {
			// 异步加载用户信息和登录状态
			setTimeout(() => {
				commit('loadUsers')
			}, 1000)
		}

	}
})